import type { PointNumber, ResolveFn } from '../types.js';

export function hardwayPayout(stake: number, n: PointNumber): number {
  if (n === 4 || n === 10) return stake * 7;
  return stake * 9;
}

export const resolveHardway: ResolveFn = (b, roll) => {
  if (b.number === undefined) throw new Error('hardway bet missing number');
  if (roll.total === b.number && roll.isHardway) {
    return { betId: b.id, outcome: 'win', payout: hardwayPayout(b.amount, b.number) };
  }
  if (roll.total === b.number || roll.total === 7) {
    return { betId: b.id, outcome: 'lose', payout: 0 };
  }
  return { betId: b.id, outcome: 'continue', payout: 0 };
};
